import styled, { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  @font-face {
    font-family: 'Galano';
    src: url(${require("../../fonts/GalanoGrotesque-Light.woff2")}) format('woff2'),
        url(${require("../../fonts/GalanoGrotesque-Light.woff")}) format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Galano';
    src: url(${require("../../fonts/GalanoGrotesque-Regular.woff2")}) format('woff2'),
        url(${require("../../fonts/GalanoGrotesque-Regular.woff")}) format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Galano';
    src: url(${require("../../fonts/GalanoGrotesque-Bold.woff2")}) format('woff2'),
        url(${require("../../fonts/GalanoGrotesque-Bold.woff")}) format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }
  :root {
    /* Colors: */
    --unnamed-color-565656: #565656;
    --unnamed-color-ffffff: #FFFFFF;
    --unnamed-color-5e5e5e: #5E5E5E;
    --unnamed-color-727272: #727272;
    --unnamed-color-505050: #505050;
    --unnamed-color-747474: #747474;
    --unnamed-color-9f9f9f: #9F9F9F;
    --unnamed-color-7b7b7b: #7B7B7B;

    --font-family: "Galano";
    --font-size-scale: 1.3;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    min-height: 100%;
    font-size: 62.5%;
  }

  body {
    font-size: 1.6rem;
    @media (max-width: 1200px) {
      padding-bottom: 80px
    }
  }

  *, button, input {
    border: 0;
    background: none;
    color: black;
    transition: color 200ms ease-out;
    outline: none;
  }
  
  button {
    cursor: pointer;
  }

  ul {
    list-style: none;
  }
`;

export const Container = styled.div`
  width: 100vw;
  height: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1440px;
`;
